<template>
    <div class="contact-select">
      <v-select
        :placeholder=placeholderSelect
        :clearable="false"
        :searchable="false"
        :options="optionsSelect"
        v-model="serviceName">
        <template #open-indicator="{ attributes }">
            <span v-bind="attributes">
                <svg class="arrow" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="https://www.w3.org/2000/svg">
                    <path d="M14.303 0.15152L8 6.45455L1.69697 0.15152L0 1.84849L8 9.84849L16 1.84849L14.303 0.15152Z" />
                </svg>
            </span>
        </template>
      </v-select>
    </div>
  </template>

  <script>
  import vSelect from "vue-select";
  import "vue-select/dist/vue-select.css";
  export default {
    components: {
      vSelect
    },
    data() {
        return {
            serviceName: '',
        }
    },
    watch: {
        // Emit trigger when new Service name is selected
        serviceName(newValue) {
            this.$emit('serviceName', newValue)
        }
    },
    props: {
        placeholderSelect: {
            type: String,
            required: false,
        },
        optionsSelect: {
            type: [Array, Object],
            required: false,
        }
    }
  };
  </script>
